const _p2 = (n) => String(n).padStart(2, '0');
// Định dạng ngày CHUẨN toàn phần mềm: dd/mm/yyyy (viết tường minh, không phụ thuộc locale).
// Nhận Date, mốc thời gian, hoặc chuỗi 'YYYY-MM-DD' / ISO.
export function fmtDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return `${_p2(d.getDate())}/${_p2(d.getMonth() + 1)}/${d.getFullYear()}`;
}
// Ngày giờ: dd/mm/yyyy HH:mm.
export function fmtDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return `${_p2(d.getDate())}/${_p2(d.getMonth() + 1)}/${d.getFullYear()} ${_p2(d.getHours())}:${_p2(d.getMinutes())}`;
}
// Thời gian tương đối tiếng Việt: "vừa xong", "X phút trước", "X giờ trước", "X ngày trước".
// Quá 7 ngày -> trả về ngày/giờ tuyệt đối cho gọn.
export function timeAgo(iso) {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  if (isNaN(t)) return '';
  const sec = Math.floor((Date.now() - t) / 1000);
  if (sec < 45) return 'vừa xong';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} phút trước`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} giờ trước`;
  const day = Math.floor(hr / 24);
  if (day <= 7) return `${day} ngày trước`;
  return fmtDateTime(iso);
}
// Định dạng số tiền giống phần mềm SocSon: dấu PHẨY ngăn cách hàng nghìn/triệu/tỷ,
// dấu chấm cho phần thập phân. Viết tường minh để không phụ thuộc locale của trình duyệt.
export function fmtNum(n, decimals = 0) {
  const num = Number(n) || 0;
  const neg = num < 0;
  const fixed = Math.abs(num).toFixed(decimals);
  let [intPart, decPart] = fixed.split('.');
  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return (neg ? '-' : '') + intPart + (decPart ? '.' + decPart : '');
}
export function fmtVND(n) {
  return fmtNum(n) + 'đ';
}
export function roleName(r, isCTV) {
  if (isCTV && r === 'NV') return 'CTV Kinh doanh';
  return { GD: 'Giám đốc', CV: 'Cố vấn', TP: 'Trưởng phòng', NV: 'Nhân viên' }[r] || r;
}
export function isLate(t) {
  const rdl = new Date(t.reviewDeadline || t.deadline).getTime();
  if (t.status === 'done') return false;
  return Date.now() > rdl;
}
export function taskCompletion(t) {
  const total = t.items.length;
  if (!total) return { done: 0, total: 0, pct: 0 };
  // "KH đạt" = đã được trưởng phòng duyệt ĐẠT (note trễ chỉ phạt KPI nhân viên, KH vẫn tính đạt ở tiến độ).
  const done = t.items.filter((it) => it.state === 'approved').length;
  return { done, total, pct: Math.round((done / total) * 100) };
}
export function itemStats(t) {
  const s = { pending: 0, noted: 0, approved: 0, rejected: 0 };
  t.items.forEach((it) => {
    s[it.state] = (s[it.state] || 0) + 1;
  });
  return s;
}
